import React, { useRef, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import {
  Box,
  Button,
  DialogActions,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useCommonStyles } from "../../utils";

const CommonModal = ({
  onClose,
  open,
  title,
  children,
  sx,
  action,
  mainBoxpadding,
  modalWidth,
  maxModalWidth,
  handleMenuClose,
  currentStep,
  textAlign,
  isWarning,
  onHandleSubmit,
  onHandleCancel,
  submitButtonName,
  CancelButtonName,
  fontSize,
  buttonAlign,
  isView,
  viewActions,
  childrenPadding,
}) => {
  const { classes } = useCommonStyles();
  const scrollableContainerRef = useRef(null);

  useEffect(() => {
    if (scrollableContainerRef.current) {
      scrollableContainerRef.current.scrollTop = 0;
    }
  }, [currentStep]);

  const handleDlgClose = (event, reason) => {
    if (reason === "backdropClick") return;
    onClose?.();
  };

  return (
    <Dialog
      onClose={handleDlgClose}
      open={open}
      handleMenuClose={handleMenuClose}
      className={classes.dialog_Main}
      sx={{
        "& .MuiDialog-container": {
          alignItems: "center",
        },
        "& .MuiDialog-paper.MuiPaper-rounded": {
          width: modalWidth ? modalWidth : "30vw",
          maxWidth: maxModalWidth
            ? maxModalWidth
            : modalWidth
              ? modalWidth
              : "auto",
          // Override dialog_Main absolute + unconstrained height so tall forms fit the screen
          position: "relative !important",
          margin: "16px !important",
          padding: "20px !important",
          maxHeight: "calc(100dvh - 32px) !important",
          height: "auto",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          boxSizing: "border-box",
        },
      }}
    >
      <Box
        display={"flex"}
        justifyContent={isWarning ? "flex-end" : "space-between"}
        position={"relative"}
        flexShrink={0}
        right={{ md: "0", sm: "0", xs: "-10px" }}
        top={{ md: "0", sm: "0", xs: "-5px" }}
      >
        {!isWarning && (
          <Typography
            sx={{
              fontSize: fontSize ? fontSize : "24px",
              color: "#131313",
              fontFamily: "Satoshi-Bold",
              textAlign: textAlign ? textAlign : "left",
            }}
          >
            {title}
          </Typography>
        )}
        <IconButton
          color="default"
          size="medium"
          onClick={() => onClose()}
          aria-label="Close"
          sx={{
            bgcolor: "#F5F9FB",
            color: (theme) => theme.palette.bgBlack.main,
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      {isWarning && (
        <>
          <ErrorOutlineIcon
            fontSize="large"
            sx={{
              color: "#E77843",
              margin: "auto",
              mb: 2,
              height: "54px",
              width: "54px",
            }}
          />
          <Box
            sx={{
              padding: mainBoxpadding
                ? mainBoxpadding
                : { md: "0 24px", sm: "0 18px", xs: "12px 0" },
              ...sx,
            }}
          >
            <Typography
              sx={{
                fontSize: fontSize ? fontSize : "18px",
                color: "#131313",
                fontFamily: "Satoshi-Bold !important",
                textAlign: textAlign ? textAlign : "left",
              }}
            >
              {title}
            </Typography>
          </Box>
        </>
      )}

      <Box
        ref={scrollableContainerRef}
        sx={{
          padding: childrenPadding ? childrenPadding : "16px 0",
          overflowY: "auto",
          overflowX: "hidden",
          flex: "1 1 auto",
          minHeight: 0,
          // Visible thin scrollbar so users know content scrolls
          scrollbarWidth: "thin",
          "&::-webkit-scrollbar": { width: 6 },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#c8d3d9",
            borderRadius: 8,
          },
        }}
      >
        {children}
      </Box>

      {action && <DialogActions>{action}</DialogActions>}
      <Box
        display={"flex"}
        flexShrink={0}
        pt={1}
        justifyContent={
          buttonAlign
            ? buttonAlign
            : {
                xs: "center",
                sm: "flex-start",
                md: "flex-start",
              }
        }
        gap={"9px"}
      >
        {isView ? (
          <>
            <Button className={classes.cancelButton} onClick={onClose}>
              {"Close"}
            </Button>
            {viewActions}
          </>
        ) : buttonAlign ? (
          <>
            <Button className={classes.cancelButton} onClick={onHandleCancel}>
              {CancelButtonName || "Cancel"}
            </Button>
            <Button className={classes.saveButton} onClick={onHandleSubmit}>
              {submitButtonName || "Save"}
            </Button>
          </>
        ) : (
          <>
            <Button className={classes.saveButton} onClick={onHandleSubmit}>
              {submitButtonName || "Save"}
            </Button>
            <Button className={classes.cancelButton} onClick={onHandleCancel}>
              {CancelButtonName || "Cancel"}
            </Button>
          </>
        )}
      </Box>
    </Dialog>
  );
};

export default CommonModal;
